import React, {Component} from "react";
import {Modal, ModalFooter, ModalHeader} from "reactstrap";
import {ClientRow} from "./agency/ClientRow";
import {APIClient} from "../utils/APIClient";
import {ERROR_AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT} from "../settings/settings";
import {API_URL} from "../settings/local_settings";
import {SaveButton} from "./business_units/SaveButton";
import { withTranslation } from 'react-i18next';


class ClientsContentBaseClass extends Component {
    constructor(props) {
        super(props);
        this.handleAgencyClientDelete = this.handleAgencyClientDelete.bind(this);
        this.handleAgencyClientStatusChange = this.handleAgencyClientStatusChange.bind(this);
        this.handleActivateAgencyClientLinkingAdAccountsToClient = this.handleActivateAgencyClientLinkingAdAccountsToClient.bind(this);
        this.state = {
            'clients': null,
            'is_confirming_to_link_ad_accounts_to_client': false,
            'agency_client_activating_id': null,
            'is_saving': false,
            'userName': null,
            'isSuperAdmin': false
        };
    }
    handleActivateAgencyClientLinkingAdAccountsToClient() {
        this.handleAgencyClientStatusChange(this.state.agency_client_activating_id, ClientRow.action_activate, true);
    }

    componentDidMount(){
        this.fetchLoggedUserData();
        this.updateAgencyData();
    }

    fetchLoggedUserData() {
        new APIClient(API_URL + 'get-logged-user-data/').call('GET').then((data) => {
            if (data && data.status === 'OK') {
                this.setState({isSuperAdmin: data.is_super_admin === true});
            }
        }).catch(() => {
            // Leave super admin actions hidden if the user data endpoint is unavailable
        });
    }


    set_is_saving(new_value) {
        this.setState({
            ...this.state,
            'is_saving': new_value
        });
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    handleAgencyClientStatusChange(agencyClientId, action, comingFromModal=false) {
        this.set_is_saving(true);

        new APIClient(API_URL + `client/${agencyClientId}/${action}`).call('PUT', {'add_ada_to_cli_if_none': comingFromModal}).then((data) => {
            if (data.status === ERROR_AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT) {
                // alert(data.error_message);
                this.setState({
                    ...this.state,
                    'is_confirming_to_link_ad_accounts_to_client': true,
                    'agency_client_activating_id': agencyClientId,
                    'is_saving': false
                });
            } else if (data.status === 'ERROR') {
                alert(data['error_message']);
            }

            this.set_is_saving(false);

            this.updateAgencyData(comingFromModal);
        })
    }

    getClientsDataURL() {
        return API_URL + 'agency/clients/'
    }

    updateAgencyData(forceCloseModal=false) {
        new APIClient(this.getClientsDataURL()).call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'OK') {

                let modalState = {
                    'is_confirming_to_link_ad_accounts_to_client': this.state.is_confirming_to_link_ad_accounts_to_client,
                    'agency_client_activating_id': this.state.agency_client_activating_id
                }

                if(forceCloseModal) {
                    modalState = {
                        'is_confirming_to_link_ad_accounts_to_client': false,
                        'agency_client_activating_id': null
                    }
                }

                this.setState({
                    ...this.state,
                    ...modalState,
                    'clients': data.data
                });
            }
        });
    }

    toggleConfirmingLinksAdAccounts() {
        // Si estamos saliendo del modal sin aceptar
        if(this.state.is_confirming_to_link_ad_accounts_to_client) {
            this.setState({
                ...this.state,
                'is_confirming_to_link_ad_accounts_to_client': false,
                'agency_client_activating_id': null

            });
        }
        else{
            throw new Error("no tenia que haber llegado aca")
        }
    }

    handleAgencyClientDelete(agencyClientId) {
        const deleteAgencyClientURL = this.getDeleteAgencyClientURL(agencyClientId)
        new APIClient(deleteAgencyClientURL).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.updateAgencyData();
            }
        })
    }

    getDeleteAgencyClientURL(agencyClientId) {
        return `${API_URL}client/${agencyClientId}/delete`
    }

    renderActivationModal() {
        const { t } = this.props;
        return <Modal key="modal" isOpen={this.state.is_confirming_to_link_ad_accounts_to_client}
                      toggle={this.toggleConfirmingLinksAdAccounts} className="modal-body">
            <ModalHeader toggle={this.toggleConfirmingLinksAdAccounts}>{t('clients.link_ad_accounts_title')}</ModalHeader>
            <div className="modal-section">
                <p>{t('clients.link_ad_accounts_message')}<br/><br/></p>
                <p>{t('clients.link_ad_accounts_question')}</p>
            </div>
            <ModalFooter>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    textAlign: "center",
                    clear: "both"
                }}>
                    <div style={{margin: "0 10px"}}>
                        <input onClick={this.toggleConfirmingLinksAdAccounts} type="button" value={t('client.no_button')}
                               className="btn -alt"/>
                    </div>
                    <div style={{margin: "0 10px"}}>
                        <SaveButton text={t('client.yes_button')} isSaving={this.state.is_saving}
                                    onClick={this.handleActivateAgencyClientLinkingAdAccountsToClient}
                                    hasChanges={true}/>
                        {/*<input onClick={this.handleActivateBusinessUnitLinkingAdAccountsToClient} type="button" value="Sí" className="btn -alt"/>*/}
                    </div>
                </div>
            </ModalFooter>
        </Modal>;
    }
}

export { ClientsContentBaseClass as ClientsContentBase };
export const ClientsContentBaseWithTranslation = withTranslation()(ClientsContentBaseClass);
